'use client';

// Legacy: pro-frontend/src/app/forgot/forgot.component.ts

import Link from 'next/link';
import { FormEvent, useState } from 'react';
import { toast } from 'sonner';

import { AuthChrome } from './AuthChrome';
import { forgotPassword, validateEmail } from './login-auth';

type ForgotPasswordPageClientProps = {
  webDomain: string;
};

export function ForgotPasswordPageClient({ webDomain }: ForgotPasswordPageClientProps) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (loading) {
      return;
    }
    if (!validateEmail(email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      const result = await forgotPassword(email.trim());
      if (!result.ok) {
        toast.error(result.message);
        return;
      }
      toast.success(result.message);
      setEmail('');
    } catch {
      toast.error('Unable to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthChrome webDomain={webDomain}>
      <div className="login_pro_section login_pro_section_pass">
        <h3>Forgot Password</h3>
      </div>

      <div className="tab-content">
        <form onSubmit={handleSubmit} noValidate>
          <ul>
            <li>
              <p className="forgot_password_email">
                Don’t remember your password? No problem! Please enter the email for your account.
                A link will be sent to you, and you can create your new password.
              </p>
            </li>
            <li>
              <input
                type="email"
                name="email"
                autoComplete="email"
                placeholder="email@example.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </li>
            <li>
              <button className="sign_up_its_free pass_word_forgot" type="submit" disabled={loading}>
                {loading ? (
                  <div className="lds-facebook" aria-hidden>
                    <div />
                    <div />
                    <div />
                  </div>
                ) : (
                  <span>Send Email</span>
                )}
              </button>
            </li>
            <li>
              <p className="forgot_password_section clearfix">
                <Link href="/login" className="forgot_password_section_sign">
                  Back to Sign In
                </Link>
              </p>
            </li>
          </ul>
        </form>
      </div>
    </AuthChrome>
  );
}
